module.exports = __webpack_public_path__ + "img/downloadAPP.874ea5d4.png";